import { useAppSelector } from "app/hooks";
import { selectRosterOrgDetails } from "selectors/Roster";
import { Logo } from "./Logo";
import { shallowEqual } from "react-redux";

interface Props {
  rosterId: string;
  tournamentId: string;
  title?: string;
}

export const RosterOrgLogo = ({ rosterId, tournamentId, title }: Props) => {
  const { id: orgId, name } =
    useAppSelector(
      (state) => selectRosterOrgDetails(state, rosterId, tournamentId),
      shallowEqual
    ) || {};

  return <Logo id={orgId} title={title ?? name} type="Org" />;
};
